import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { isNative } from '../utils/platform';
import MobileLayout from './MobileLayout';
import MobileLanding from './MobileLanding';
import MobileHome from './pages/MobileHome';
import MobileAvis from './pages/MobileAvis';
import MobileInsights from './pages/MobileInsights';
import MobileFeedbacks from './pages/MobileFeedbacks';
import MobileConcurrents from './pages/MobileConcurrents';
import MobilePageClient from './pages/MobilePageClient';
import MobileCompte from './pages/MobileCompte';
import MobileProfil from './pages/MobileProfil';
import { CurrentRestaurantProvider } from './contexts/CurrentRestaurantContext';
import RestaurantSwitcher from './components/RestaurantSwitcher';
import AddRestaurantSheet from './components/AddRestaurantSheet';

// Wrapper léger : applique MobileLayout (tab bar + safe areas) autour d'une page.
// MobileLanding est volontairement EXCLU de ce wrap (page fullscreen sans tab bar).
function withLayout(node) {
  return <MobileLayout>{node}</MobileLayout>;
}

// AppShell : wrap les routes app authentifiées avec le provider multi-resto + les
// 2 bottom sheets globaux (switcher + ajout). MobileLanding (welcome) reste hors
// shell — pas de token au pré-login, le contexte ne pourrait rien fetcher.
function AppShell({ children }) {
  return (
    <CurrentRestaurantProvider>
      {children}
      <RestaurantSwitcher />
      <AddRestaurantSheet />
    </CurrentRestaurantProvider>
  );
}

export default function MobileRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  // Si on est en native ET sur une route web (qui n'est ni /m/* ni auth), rediriger
  // vers /m/home. La logique fine "token absent → /m/welcome" est gérée par
  // NativeRouteGuard côté App.js.
  useEffect(() => {
    if (isNative() && !location.pathname.startsWith('/m/') &&
        !['/login', '/register', '/forgot-password'].includes(location.pathname)) {
      navigate('/m/home', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="welcome" element={<MobileLanding />} />
      <Route path="home" element={<AppShell>{withLayout(<MobileHome />)}</AppShell>} />
      <Route path="avis" element={<AppShell>{withLayout(<MobileAvis />)}</AppShell>} />
      <Route path="insights" element={<AppShell>{withLayout(<MobileInsights />)}</AppShell>} />
      <Route path="feedbacks" element={<AppShell>{withLayout(<MobileFeedbacks />)}</AppShell>} />
      {/* Sous-pages atteintes depuis le Profil : la barre d'onglets est
          limitée à 5 entrées (recommandation Apple), on n'y ajoute rien. */}
      <Route path="concurrents" element={<AppShell>{withLayout(<MobileConcurrents />)}</AppShell>} />
      <Route path="page-client" element={<AppShell>{withLayout(<MobilePageClient />)}</AppShell>} />
      <Route path="compte" element={<AppShell>{withLayout(<MobileCompte />)}</AppShell>} />
      <Route path="profil" element={<AppShell>{withLayout(<MobileProfil />)}</AppShell>} />
      <Route path="*" element={<Navigate to="/m/home" replace />} />
    </Routes>
  );
}
